// extracted by mini-css-extract-plugin
export default {"input":"input__JTuis","__size-small":"__size-small__xWYhT","__size-default":"__size-default__zyhKX","__size-accent":"__size-accent__Gf4TY"};